import { REGEXPS } from 'constants/regexps';

export const getAddressWithApartmentString = (street?: string, apartment?: string) =>
  street && `${street}${apartment ? `, кв ${apartment}` : ''}`.replace(REGEXPS.AddressPostalCode, '');
